import axios from "axios";
import { auth, firestore } from "containers/firebase";
import { COLLECTION } from "shared/strings/firebase";

const VITE_CLOUD_FUNCTION_API_URL = import.meta.env.VITE_CLOUD_FUNCTION_API_URL;

export const addCloudTask = async (task) => {
  if (!task) {
    throw Error("task is required");
  }
  const token = await auth.currentUser.getIdToken();
  axios.post(`${VITE_CLOUD_FUNCTION_API_URL}/cloudTasksApi`, task, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

};

export const sendEmail = ({ subject, html, from, to, bcc, replyTo, headers }) => {
  const sanitizedHeaders = Object.entries(headers || {}).reduce(
    (acc, [key, value]) => {
      if (key.toLowerCase() === "content-type") {
        return acc;
      }

      return {
        ...acc,
        [key]: value,
      };
    },
    {}
  );

  const emailNotification = {
    message: {
      subject,
      html,
    },
    createdAt: new Date(),
  };

  if (from) {
    emailNotification.from = from;
  }

  if (to?.length) {
    emailNotification.to = to;
  }

  if (bcc?.length) {
    emailNotification.bcc = bcc;
  }

  if (replyTo) {
    emailNotification.replyTo = replyTo;
  }

  if (Object.keys(sanitizedHeaders).length > 0) {
    emailNotification.headers = sanitizedHeaders;
  }

  return firestore.collection(COLLECTION.Mail).add(emailNotification);
};
